import { render, staticRenderFns } from "./PItemRow1.vue?vue&type=template&id=5642e9e2"
import script from "./PItemRow1.vue?vue&type=script&lang=js"
export * from "./PItemRow1.vue?vue&type=script&lang=js"
import style0 from "./PItemRow1.vue?vue&type=style&index=0&id=5642e9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports